import { useAppSelector } from '../../../store/hooks';
import { selectViewerMode } from '../../../store/slices/shareSlice';
import { companiesApi } from '../../../store/services/CompaniesService';
import { shareApi } from '../../../store/services/DashboardShareService';

export const useCompanyStatsQuery = (companyId: string) => {
  const viewerMode = useAppSelector(selectViewerMode);
  return viewerMode
    ? shareApi.useGetCompanyStatsQuery({ companyId })
    : companiesApi.useGetCompanyStatsQuery({ companyId });
};
